import { BaseRouteService } from 'core/services';

class CoverageTypeRouteService extends BaseRouteService {
    constructor() {
        super('coverage-types');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields}', filter);
    }
}

export default CoverageTypeRouteService;
